import { trigger, transition, animate, style } from '@angular/animations';

export const Grow = trigger('Grow', [
    transition(':enter', [
        style({
            overflow: 'hidden',
            height: '0px',
            opacity: 0,
        }),
        animate(
            '0.4s cubic-bezier(0.5, 0, 0, 1)',
            style({
                height: '*',
                opacity: 1,
            }),
        ),
    ]),
    transition(':leave', [
        style({
            overflow: 'hidden',
        }),
        animate(
            '0.4s cubic-bezier(0.5, 0, 0, 1)',
            style({
                height: '0px',
                opacity: 0,
            }),
        ),
    ]),
]);
